// extracted by mini-css-extract-plugin
export default {"container":"Paragraph_container__mq5sD","text":"Paragraph_text__gjW6I","para":"Paragraph_para__7r-Qz"};